/**
 * APH macro calculator (Harry 2026-09-23). One screen, dumb maths.
 * Eat: not much 28 / average 33 / a lot 38 kcal per kg.
 * Goal: lose -20%, gain +15%. Protein 2g/kg, fat 0.8g/kg, carbs = leftover/4.
 */
(function () {
  function init(root) {
    if (!root || root.dataset.macroBound === '1') return;
    root.dataset.macroBound = '1';

    var weight = root.querySelector('[data-macro-weight]');
    var eatBtns = root.querySelectorAll('[data-macro-eat]');
    var goalBtns = root.querySelectorAll('[data-macro-goal]');
    var calcBtn = root.querySelector('[data-macro-calc]');
    var errorEl = root.querySelector('[data-macro-error]');
    var form = root.querySelector('[data-macro-form]');
    var results = root.querySelector('[data-macro-results]');

    var eat = null;
    var goal = null;

    function pick(btns, btn) {
      btns.forEach(function (b) {
        b.classList.toggle('is-selected', b === btn);
      });
    }

    /* Easier fill: Average preselected (one less tap, easy to change) */
    var avgBtn = root.querySelector('[data-macro-eat="33"]');
    if (avgBtn) {
      eat = 33;
      pick(eatBtns, avgBtn);
    }

    eatBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        eat = parseFloat(b.getAttribute('data-macro-eat'));
        pick(eatBtns, b);
      });
    });
    goalBtns.forEach(function (b) {
      b.addEventListener('click', function () {
        goal = b.getAttribute('data-macro-goal');
        pick(goalBtns, b);
      });
    });

    function show(el, on) {
      if (!el) return;
      el.hidden = !on;
      el.classList.toggle('active', on);
    }

    calcBtn.addEventListener('click', function () {
      var w = parseFloat(weight && weight.value);
      if (!w || w < 30 || w > 300 || !eat || !goal) {
        if (errorEl) errorEl.hidden = false;
        return;
      }
      if (errorEl) errorEl.hidden = true;

      var cal = w * eat * (goal === 'lose' ? 0.8 : 1.15);
      cal = Math.round(cal / 10) * 10;
      var protein = Math.round(w * 2);
      var fat = Math.round(w * 0.8);
      var carbs = Math.max(0, Math.round((cal - protein * 4 - fat * 9) / 4));

      root.querySelector('[data-macro-out-cal]').textContent = cal.toLocaleString('en-GB');
      root.querySelector('[data-macro-out-protein]').textContent = protein;
      root.querySelector('[data-macro-out-carbs]').textContent = carbs;
      root.querySelector('[data-macro-out-fat]').textContent = fat;

      var summary = root.querySelector('[data-macro-summary]');
      if (summary) {
        summary.textContent =
          'At ' +
          w +
          'kg, eating ' +
          (eat === 28 ? 'not much' : eat === 33 ? 'an average amount' : 'a lot') +
          ' to ' +
          (goal === 'lose' ? 'lose weight.' : 'gain weight.');
      }

      show(form, false);
      show(results, true);
      results.scrollIntoView({ behavior: 'smooth', block: 'start' });

      /* Stash targets for the meal plan button */
      root._macroTargets = { cal: cal, protein: protein, carbs: carbs, fat: fat };
      var planBtn = root.querySelector('[data-macro-mealplan]');
      var planOut = root.querySelector('[data-macro-mealplan-out]');
      if (planBtn && planOut && !planBtn.dataset.bound) {
        planBtn.dataset.bound = '1';
        planBtn.addEventListener('click', function () {
          if (window.APHMealPlan && root._macroTargets) {
            /* Building spinner first - never dump the plan instantly */
            planOut.hidden = false;
            planOut.innerHTML =
              '<div class="aph-meal-plan-building"><span class="aph-meal-plan-spinner" aria-hidden="true"></span>Building your meal plan</div>';
            planOut.scrollIntoView({ behavior: 'smooth', block: 'start' });
            var sendBox = root.querySelector('[data-macro-mealplan-send]');
            setTimeout(function () {
              var logoEl = root.querySelector('[data-logo-url]');
              window.APHMealPlan.render(planOut, root._macroTargets, {
                logoUrl: logoEl ? logoEl.getAttribute('data-logo-url') : null,
                wheyImg: logoEl ? logoEl.getAttribute('data-whey-img') : null,
                showPrintButton: false,
              });
              if (sendBox) sendBox.hidden = false;
            }, 1200);
          }
        });
      }

      /* Standalone planner: render the plan straight away (no extra click) */
      var autoPlan = root.querySelector('[data-mealplan-auto]');
      if (autoPlan && window.APHMealPlan) {
        var logoEl2 = root.querySelector('[data-logo-url]');
        window.APHMealPlan.render(autoPlan, root._macroTargets, {
          logoUrl: logoEl2 ? logoEl2.getAttribute('data-logo-url') : null,
          wheyImg: logoEl2 ? logoEl2.getAttribute('data-whey-img') : null,
          showPrintButton: false,
        });
      }
    });

    var again = root.querySelector('[data-macro-again]');
    if (again) {
      again.addEventListener('click', function () {
        show(results, false);
        show(form, true);
        form.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    }

    /* Weight stepper: minus left, number middle, plus right */
    root.querySelectorAll('[data-macro-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var dir = parseFloat(btn.getAttribute('data-macro-step')) || 0;
        var cur = parseFloat(weight.value);
        if (isNaN(cur)) cur = 80;
        var next = Math.round((cur + dir) * 2) / 2;
        if (next < 30) next = 30;
        if (next > 300) next = 300;
        weight.value = next;
      });
    });

    /* Copy tidy macro block (normal dashes) */
    var copyBtn = root.querySelector('[data-macro-copy]');
    if (copyBtn) {
      copyBtn.addEventListener('click', function () {
        var lines = [
          'Calories - ' + root.querySelector('[data-macro-out-cal]').textContent,
          'Protein - ' + root.querySelector('[data-macro-out-protein]').textContent + 'g',
          'Carbs - ' + root.querySelector('[data-macro-out-carbs]').textContent + 'g',
          'Fat - ' + root.querySelector('[data-macro-out-fat]').textContent + 'g',
        ].join('\n');
        var note = root.querySelector('[data-macro-copy-note]');
        function done() {
          if (note) {
            note.hidden = false;
            setTimeout(function () {
              note.hidden = true;
            }, 1600);
          }
        }
        if (navigator.clipboard && navigator.clipboard.writeText) {
          navigator.clipboard.writeText(lines).then(done, function () {
            window.prompt('Copy your macros:', lines);
          });
        } else {
          window.prompt('Copy your macros:', lines);
        }
      });
    }
  }

  function boot() {
    document.querySelectorAll('.macro-page').forEach(init);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
  document.addEventListener('shopify:section:load', boot);
})();
